/* eslint-env browser */
import inherit from 'component-inherit';
import Query from './query';

const ua = navigator.userAgent;

/**
 * Creates an Mac instance
 */

export default function MacOS() {
  if (!(this instanceof MacOS)) {
    return new MacOS();
  }

  this.name = 'Mac OS';
  this.uaname = 'mac os';
  const match = ua.match(/mac os ([^)]+)\)/i);
  this.version = match ? `OS ${match[1]}` : false;
}

/**
 * Inherits MacOS from Query
 */

inherit(MacOS, Query);



// WEBPACK FOOTER //
// ./src/modules/npm-component/user-agent/mac.js